// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yxTj_","left":"styles_left__jQxJF","desktopActions":"styles_desktopActions__2pVBx","title":"styles_title__2m1c7"};